<template>
  <Card class="inputWrapper" :class="{ 'input-error': !!error }">
    <div class="inputAndLabel">
      <div v-if="label" class="label">{{ label }}</div>
      <div class="inputContainer">
        <slot />
        <button class="clearable" @click="emit('clear')">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
    </div>
    <div v-if="error" class="errorMessage">
      <i class="fa fa-exclamation-circle mr-1"></i><span>{{ error }}</span>
    </div>
  </Card>
</template>

<script setup lang="ts">
import Card from "@/components/Card.vue";

defineProps({
  error: {
    type: String,
    default: () => ""
  },
  label: {
    type: String,
    default: () => ""
  }
});

const emit = defineEmits(["clear"]);
</script>

<style lang="scss" scoped>
.inputWrapper.input-error {
  border: 1px solid #ff0000;
}
.errorMessage {
  color: #ff0000;
  margin-top: 3px;
  margin-right: 3px;
  text-align: right;
  font-size: 13px;
}
.inputAndLabel {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.label {
  font-size: 14px;
  line-height: 18px;
  margin-right: 15px;
}
.inputContainer {
  display: flex;
  margin-left: auto;
  position: relative;
  margin-right: 39px;
}
.clearable {
  height: 100%;
  width: 39px;
  font-size: 14px;
  position: absolute;
  right: -35px;
  background: #fff;
  border: 1px solid #ddd;
  border-left: 0;
  border-radius: 0px 3px 3px 0px;
}
</style>
